import Vue from "vue";
export default {
  isDeliveryTypeAvailble(dates_collection, settings) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    let future_order_time = settings.accepts_future_orders
      ? settings.future_order_delivery
      : 0;

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );

          let now_with_future = Vue.prototype.$moment(
            Vue.prototype
              .$moment(
                full_open_at
                  .clone()
                  .subtract(future_order_time, "h")
                  .toDate()
              )
              .format("YYYY-MM-DD HH:mm:ss"),
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            (now.isSameOrAfter(full_open_at) &&
              now.isSameOrBefore(full_close_at)) ||
            (settings.accepts_future_orders &&
              now.isSameOrAfter(now_with_future) &&
              now.isSameOrBefore(full_open_at))
          ) {
            return true;
          }
        }
      } else if (settings.accepts_future_orders && date_element.isAfter(now)) {
        // date is in the futur
        return true;
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },
  isCollectionTypeAvailble(dates_collection, settings) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    let future_order_time = settings.accepts_future_orders
      ? settings.future_order_collection
      : 0;

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );

          let now_with_future = Vue.prototype.$moment(
            Vue.prototype.$moment(
              full_open_at
                .clone()
                .subtract(future_order_time, "h")
                .toDate()
            )
              .format("YYYY-MM-DD HH:mm:ss"),
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            (now.isSameOrAfter(full_open_at) &&
              now.isSameOrBefore(full_close_at)) ||
            (settings.accepts_future_orders &&
              now.isSameOrAfter(now_with_future) &&
              now.isSameOrBefore(full_open_at))
          ) {
            return true;
          }
        }
      } else if (settings.accepts_future_orders && date_element.isAfter(now)) {
        // date is in the futur
        return true;
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },
  isTableTypeAvailble(dates_collection) {
    let array_dates = Object.keys(dates_collection);

    if (!array_dates.length) return false;

    let now = Vue.prototype.$moment(new Date());

    for (let k = 0; k < array_dates.length; k++) {
      let str_elemnt = array_dates[k];
      var date_values = dates_collection[str_elemnt];
      if (!date_values) continue;
      let date_element = Vue.prototype.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

      //--- if the first element is today
      if (date_element.isSame(Vue.prototype.$moment(now), "day")) {
        //--- check the time depend on today
        for (let i = 0; i < date_values.length; i++) {
          let full_open_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].opens_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          let full_close_at = Vue.prototype.$moment(
            now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
            "YYYY-MM-DD HH:mm:ss"
          );
          if (
            now.isSameOrAfter(full_open_at) &&
            now.isSameOrBefore(full_close_at)
          ) {
            return true;
          }
        }
      }
    }
    Vue.nextTick(() => {
      return false;
    });
  },
  compareValues(sortBy) {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) return 0;

      const varA =
        typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
      const varB =
        typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

      let comparaison = 0;
      if (varA > varB) comparaison = 1;
      else if (varB > varA) comparaison = -1;

      return comparaison;
    };
  },
};
